import {
  SAVE_ALL_SPACER,
  SAVE_ALL_SHISHE,
  SAVE_ALL_SHISHE_GROUP,
  SAVE_ALL_MAHSOOLE_SHISHE,
  SAVE_SELECT_GROUP_GLASS,
  SAVE_SELECT_JEDARE,
  SAVE_SELECT_SHISHE,
  SAVE_SELECT_SPACER,
  ACTION_GET_MAHSOOLE_SHISHE_RELATION,
  ACTION_GET_SHISHE_RELATION,
  ACTION_GET_SHISHE_GROUP_RELATION,
  ACTION_GET_SPACER_RELATION,
  MAHSOOLE_SHISHE_SEARCH,
  EDIT_GLASS_DETAIL,
  GLASS_COLOR_LIST
} from "Stores/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  spacers: [],
  shishe: [],
  shisheGroup: [],
  mahsooleShishe: [],
  groupGlassList: [],
  jedareList: [],
  glassList: [],
  colorList: [],
  spacerList: [],
  dataRelationMahsooleShishe: [],
  dataRelationShishe: [],
  dataRelationShisheGroup: [],
  dataRelationSpacer: [],
  mahsooleShishePagination: { Limit: 10, Page: 1, Total: 0 },
  spacersPagination: { Limit: 10, Page: 1, Total: 0 },
  shishePagination: { Limit: 10, Page: 1, Total: 0 },
  shisheGroupPagination: { Limit: 10, Page: 1, Total: 0 },
  mahsooleShisheDataSearch: null,
  editGlassDetail: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_GLASS_DETAIL:
      return updateObject(state, { editGlassDetail: action.editGlassDetail });
    case SAVE_ALL_MAHSOOLE_SHISHE:
      return updateObject(state, {
        mahsooleShishe: action.mahsooleShishe,
        mahsooleShishePagination: action.mahsooleShishePagination,
      });
    case MAHSOOLE_SHISHE_SEARCH:
      return updateObject(state, {
        mahsooleShisheDataSearch: action.mahsooleShisheDataSearch,
      });
    case SAVE_SELECT_GROUP_GLASS:
      return updateObject(state, {
        groupGlassList: action.groupGlassList,
      });
    case SAVE_SELECT_JEDARE:
      return updateObject(state, { jedareList: action.jedareList });
    case SAVE_SELECT_SHISHE:
      return updateObject(state, { glassList: action.glassList });
    case GLASS_COLOR_LIST:
      return updateObject(state, { colorList: action.colorList });
    case SAVE_SELECT_SPACER:
      return updateObject(state, { spacerList: action.spacerList });
    case SAVE_ALL_SPACER:
      return updateObject(state, {
        spacers: action.spacers,
        spacersPagination: action.spacersPagination,
      });
    case SAVE_ALL_SHISHE:
      return updateObject(state, {
        shishe: action.shishe,
        shishePagination: action.shishePagination,
      });
    case SAVE_ALL_SHISHE_GROUP:
      return updateObject(state, {
        shisheGroup: action.shisheGroup,
        shisheGroupPagination: action.shisheGroupPagination,
      });
    case ACTION_GET_MAHSOOLE_SHISHE_RELATION:
      return updateObject(state, {
        dataRelationMahsooleShishe: action.dataRelationMahsooleShishe,
      });
    case ACTION_GET_SHISHE_RELATION:
      return updateObject(state, {
        dataRelationShishe: action.dataRelationShishe,
      });
    case ACTION_GET_SHISHE_GROUP_RELATION:
      return updateObject(state, {
        dataRelationShisheGroup: action.dataRelationShisheGroup,
      });
    case ACTION_GET_SPACER_RELATION:
      return updateObject(state, {
        dataRelationSpacer: action.dataRelationSpacer,
      });
    default:
      return state;
  }
};

export default reducer;
